import { render } from "./FormUploadImage.vue?vue&type=template&id=1fa96945&scoped=true"
import script from "./FormUploadImage.vue?vue&type=script&lang=js"
export * from "./FormUploadImage.vue?vue&type=script&lang=js"

import "./FormUploadImage.vue?vue&type=style&index=0&id=1fa96945&scoped=true&lang=scss"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-1fa96945"]])

export default __exports__